<template>
    <ModalComponent
        :name="'whatsapp-' + id"
        title="Enviar entradas"
        v-on:close="() => close(false)"
    >
        <ValidationObserver tag="form" ref="observer" @submit.prevent="submit">
            <div class="row">
                <div class="col-12">
                    <h3 class="font-weight-bold">Se enviarán las siguientes entradas</h3>
                </div>
                <div class="col-12">
                    <div class="table-responsive">
                        <table class="table table-hover text-nowrap">
                            <thead>
                                <tr>
                                    <th>Descripción</th>
                                    <th>Precio + G.G</th>
                                    <th>Código qr</th>
                                    <th>Zona</th>
                                    <th>Fila/Asiento</th>
                                </tr>
                            </thead>
                            <tbody>
                                <template v-for="(entrada, index) in pedido?.entradas">
                                    <tr :key="index">
                                        <td>{{ entrada.concepto }}</td>
                                        <td>{{ entrada.precio | calcular_precio_entrada(entrada) }} </td>
                                        <td>{{ entrada.qr_code }}</td>
                                        <td>{{ entrada.asiento ? entrada.asiento.zona : '' }}</td>
                                        <td>
                                            <template v-if="entrada.asiento">
                                                {{ entrada.asiento.fila }}/{{ entrada.asiento.asiento }}
                                            </template>
                                        </td>
                                    </tr>
                                </template>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="col-12">
                    <label>Telefono</label>
                    <PhoneInput
                        :phone="telefono ?? null"
                        :required="true"
                        @setNumber="(number) => telefono = number"
                        @validNumber="(valid) => isValidNumber = valid"
                    />
                    <FormInput class="pt-2" label="Nombre" type="text" name="nombre" rules="required" v-model="nombre" />
                    <FormInput label="Apellidos" type="text" name="apellidos" rules="required" v-model="apellidos" />
                </div>
                <div class="col-12">
                    <Button type="submit" name="button" :disabled="loading">ENVIAR</Button>
                </div>
            </div>
        </ValidationObserver>
    </ModalComponent>
</template>

<script>
    import ModalComponent from "@/components/backend/components/ModalComponent";
    import PhoneInput from '@/components/common/PhoneInput.vue';

    export default {
        props: ['id', 'user_order', 'sesion_id', 'evento_id', 'pedido'],
        data() {
            return {
                telefono: null,
                nombre: null,
                apellidos: null,
                loading: false
            }
        },
        created() {
            if(this.pedido?.nombre){
                this.nombre = this.pedido.nombre
            }
            if(this.pedido?.apellidos){
                this.apellidos = this.pedido.apellidos
            }
            if(this.pedido?.telefono) {
                this.telefono = this.pedido.telefono;
            }
        },
        methods: {
            close() {
                this.$emit('close', 'whatsapp-' + this.id);
            },
            enviarEntradas : function() {
                this.loading = true;
                var data = {
                    filters: {
                        evento_id: this.evento_id,
                        sesion_id: this.sesion_id,
                        user_order: this.user_order,
                        qr_codes: [],
                        telefono: this.telefono,
                        nombre: this.nombre
                    },
                    evento_id: this.evento_id,
                    sesion_id: this.sesion_id,
                    user_order: this.user_order,
                    qr_codes: [],
                    telefono: this.telefono,
                    nombre: this.nombre,
                    apellidos: this.apellidos
                };

                for(var i in this.pedido?.entradas) {
                    data.qr_codes.push(this.pedido.entradas[i].qr_code);
                }

                this.$store.dispatch(this.config.getVuexAlias('back.events.sesiones.pedido.enviar.whatsapp'), data).then(res => {
                    this.$toast.success('Entradas enviadas correctamente');
                    this.$emit('updated');
                }).catch(err => {
                    this.$toast.error('Error al enviar las entradas');
                }).finally(() => this.loading = false);
            },
            async submit() {
                const isValid = await this.$refs.observer.validate();
                if(isValid) {
                    this.enviarEntradas();
                }
            }
        },
        components: {
            ModalComponent, PhoneInput
        }
    }
</script>
